(function () {
    // Filename sorts before "dropdown.js" (gulp concatenates assets/js/*.js
    // alphabetically) so this runs first and hands dropdown.js's overflow
    // logic an already-resolved, single, nested menu — not two flat ones.

    var isTH = window.location.pathname.indexOf('/th/') === 0;

    // Both nav lists and both switcher links are always server-rendered
    // (see partials/site-nav.hbs — the layout can't see the current page's
    // own tags to pick one server-side). Drop whichever doesn't apply.
    Array.prototype.forEach.call(document.querySelectorAll('.gh-head-menu [data-nav-lang]'), function (list) {
        if ((list.getAttribute('data-nav-lang') === 'th') !== isTH) {
            list.remove();
        } else {
            list.hidden = false;
        }
    });
    // Guess the matching page in the other language. Documented in
    // README-bilingual.md:
    //  - plain /{slug}/ content pages <-> /th/{slug}-th/
    //  - /tag/{slug}/ archives are language-neutral (no Thai variant) —
    //    switching just keeps you on the same archive.
    // Anything else (author archives, pagination, etc.) falls back to the
    // language homepage rather than producing a nonsense URL — no
    // existence check beyond what's above, so a bad guess 404s like any
    // other broken link would.
    var currentSlug = window.location.pathname.replace(/^\/|\/$/g, '');
    var switchTarget;
    if (isTH) {
        var rest = currentSlug.replace(/^th\//, '');
        var tagMatch = rest.match(/^tag\/([^/]+)$/);
        var isPlainSlug = rest.indexOf('/') === -1 && /-th$/.test(rest);
        if (isPlainSlug) {
            switchTarget = '/' + rest.replace(/-th$/, '') + '/';
        } else if (tagMatch) {
            switchTarget = '/tag/' + tagMatch[1] + '/';
        } else {
            switchTarget = '/';
        }
    } else {
        var isTopLevel = currentSlug !== '' && currentSlug.indexOf('/') === -1;
        var enTagMatch = currentSlug.match(/^tag\/([^/]+)$/);
        if (isTopLevel) {
            switchTarget = '/th/' + currentSlug + '-th/';
        } else if (enTagMatch) {
            switchTarget = '/tag/' + enTagMatch[1] + '/'; // stays put, tag archives are language-neutral
        } else {
            switchTarget = '/th/';
        }
    }

    Array.prototype.forEach.call(document.querySelectorAll('[data-lang-switch]'), function (link) {
        // data-lang-switch="th" = the link that switches you TO Thai -> only makes sense on an EN page.
        var switchesToTH = link.getAttribute('data-lang-switch') === 'th';
        if (switchesToTH === isTH) {
            link.remove();
        } else {
            link.hidden = false;
            link.href = switchTarget;
        }
    });

    var nav = document.querySelector('.gh-head-menu .nav');
    if (!nav) return;

    var normalize = function (pathname) {
        return pathname.replace(/\/$/, '') || '/';
    };
    var currentPath = normalize(window.location.pathname);

    // Snapshot children before mutating — nav.children is a live collection
    // and moving items into a submenu mid-loop would skip siblings.
    var items = Array.prototype.slice.call(nav.children);
    var lastTop = null;

    items.forEach(function (li) {
        var a = li.querySelector('a');
        if (!a) return;

        // Matches the site's existing nav-editor convention: a label
        // starting with "-" nests under the preceding top-level item
        // (e.g. "- About Us" under "About").
        var text = a.textContent.trim();
        var isChild = text.charAt(0) === '-';
        if (isChild && lastTop) {
            a.textContent = text.replace(/^-+\s*/, '');

            var sub = lastTop.querySelector(':scope > .nav-sub');
            if (!sub) {
                lastTop.classList.add('has-sub');

                var toggle = document.createElement('button');
                toggle.className = 'nav-sub-toggle';
                toggle.type = 'button';
                toggle.setAttribute('aria-label', 'Show submenu');
                toggle.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="10" height="10"><path fill="currentColor" d="M12 16l-8-8h16z"/></svg>';
                lastTop.appendChild(toggle);

                sub = document.createElement('ul');
                sub.className = 'nav-sub';
                lastTop.appendChild(sub);
            }
            sub.appendChild(li);
        } else {
            a.textContent = text;
            lastTop = li;
        }

        try {
            var linkUrl = new URL(a.getAttribute('href'), window.location.origin);
            if (normalize(linkUrl.pathname) === currentPath) {
                li.classList.add('nav-current');
            }
        } catch (e) {
            // relative/hash links (e.g. #/portal/signin) — nothing to compare
        }
    });

    // Submenus open on hover/click and stay open through a short grace
    // period on mouse-out — without it, the gap between the parent link
    // and the dropdown below it closes the menu the instant the cursor
    // crosses it, before a click can land.
    var CLOSE_DELAY_MS = 300;
    var closeTimer = null;

    function closeAllExcept(exceptLi) {
        Array.prototype.forEach.call(nav.querySelectorAll('.has-sub.is-open'), function (li) {
            if (li !== exceptLi) li.classList.remove('is-open');
        });
    }

    Array.prototype.forEach.call(nav.querySelectorAll('.has-sub'), function (li) {
        li.addEventListener('mouseenter', function () {
            clearTimeout(closeTimer);
            closeAllExcept(li);
            li.classList.add('is-open');
        });
        li.addEventListener('mouseleave', function () {
            closeTimer = setTimeout(function () {
                li.classList.remove('is-open');
            }, CLOSE_DELAY_MS);
        });
    });

    // Tap-to-open (touch devices, and desktop as a click-instead-of-hover option)
    nav.addEventListener('click', function (e) {
        var toggle = e.target.closest && e.target.closest('.nav-sub-toggle');
        if (!toggle) return;
        e.preventDefault();
        clearTimeout(closeTimer);

        var parentLi = toggle.closest('.has-sub');
        var wasOpen = parentLi.classList.contains('is-open');
        closeAllExcept(parentLi);
        parentLi.classList.toggle('is-open', !wasOpen);
    });
})();
